import React  from 'react';

const WarningIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="12.448" height="10.893" viewBox="0 0 12.448 10.893">
  <path id="triangle-exclamation-solid" d="M6.26,32a.971.971,0,0,1,.839.481l5.252,8.948a.972.972,0,0,1-.839,1.464H1.009A.972.972,0,0,1,.17,41.429l5.252-8.948A.971.971,0,0,1,6.26,32Zm0,3.112a.582.582,0,0,0-.584.584v2.723a.584.584,0,0,0,1.167,0V35.7A.582.582,0,0,0,6.26,35.112Zm.778,5.446a.778.778,0,1,0-.778.778A.778.778,0,0,0,7.038,40.558Z" transform="translate(-0.037 -32)" fill="#ffc65a"/>
</svg>


}

export default WarningIcon;
